import { IconButton } from '@chakra-ui/react';
import { IconSettingsSliderHor } from 'central-icons/IconSettingsSliderHor';

import { RevelioTooltip } from '@revelio/ui';

import styles from './customise-columns-button.module.css';

interface CustomiseColumnsButtonProps {
  onClick: () => void;
  right?: number;
  variant?: 'default' | 'compact';
  height?: string;
  hideTopRightRadius?: boolean;
}

export const CustomiseColumnsButton = ({
  onClick,
  right,
  variant = 'default',
  height,
  hideTopRightRadius = false,
}: CustomiseColumnsButtonProps) => {
  const isCompact = variant === 'compact';

  return (
    <RevelioTooltip label="Manage Columns" placement="top">
      <IconButton
        className={styles.button}
        position="absolute"
        right={right}
        width={isCompact ? '32px' : '44px'}
        height={height ?? (isCompact ? '38px' : '42px')}
        background="white"
        aria-label="Manage Columns"
        icon={
          <IconSettingsSliderHor
            color="var(--ccb-icon, #555e68)"
            size={isCompact ? '16px' : '18px'}
          />
        }
        border={isCompact ? 'none' : '1px solid #E4E3E2'}
        borderTop={
          isCompact ? '1px solid var(--chakra-colors-lightBlueGray)' : undefined
        }
        borderLeft={isCompact ? 'none' : undefined}
        borderRight={
          isCompact ? '1px solid var(--chakra-colors-lightBlueGray)' : undefined
        }
        colorScheme="gray"
        onClick={onClick}
        boxShadow={
          isCompact
            ? '-6px 0 4px -2px rgba(45, 66, 106, 0.10)'
            : '0 0 8px 5px rgba(45, 66, 106, 0.10)'
        }
        clipPath={
          isCompact
            ? undefined
            : 'polygon(-20% 0%, 86% 0%, 100% 14%, 100% 100%, -20% 100%)'
        }
        _focus={{
          boxShadow: isCompact
            ? '-6px 0 4px -2px rgba(45, 66, 106, 0.10) !important'
            : '0 0 8px 5px rgba(45, 66, 106, 0.10) !important',
        }}
        {...(hideTopRightRadius
          ? { borderRadius: '0 0 0 0' }
          : {
              style: isCompact
                ? { borderRadius: '0 6px 0 0' }
                : { borderRadius: '0 10px 0 0' },
            })}
        data-testid="manage-table-columns-button"
      />
    </RevelioTooltip>
  );
};
